import React from 'react';
import Grid from '@material-ui/core/Grid';
import { AppBar, Toolbar, Menu, MenuItem } from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import MobileNavigationMenu from './Menu/MobileNavigation';
import HomeNav from './Menu/HomeNav';
import NationalNav from './Menu/NationalNav';
import sart_logo_mobile from '../images/sart_logo_mobile.png';
import sart_logo from '../images/sart_logo.png';

const sartPrimaryTheme = createMuiTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#42738D',
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            main: '#E48A0A',
        },
        error: {
            main: "#AB3737",
        }
    },
    typography: {
        fontFamily: [
            "'Roboto'",
            '"sans-serif"',
        ].join(','),
        primary: {
            main: "#42738D",
        },
        secondary: {
            main: "#E48A0A",
        }
    }
});

const sartLogoBar = createMuiTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#ffffff',
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            main: '#4C9462',
        },
    },
});

class Navigation extends React.Component {
    constructor(props) {
        //override state here
        super(props);
        this.state = {
            anchorNat: null,
            base_url: '',
            anchorHome: null
        }

        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.navigate = this.navigate.bind(this);

        this.handleClickHome = this.handleClick.bind(this);
        this.handleCloseHome = this.handleClose.bind(this);
    }

    handleClick(event) {
        this.setState({
            anchorNat: event.target
        })
    }

    handleClose() {
        this.setState({
            anchorNat: null
        })
    }

    handleClickHome(event) {
        this.setState({
            anchorHome: event.target
        })
    }

    handleCloseHome() {
        this.setState({
            anchorHome: null
        })
    }

    componentDidMount() {
        let base_url = this.props.base_url;
        this.setState({
            base_url: base_url
        });
    }

    navigate(target) {
        if (target === "MemberLogin") {
            this.props.ga_event('Navigation', 'Member Login Clicked');
            window.location.assign("https://www.sart.org/login/?returnurl=/");
        }
        if (target === "MemberResources") {
            this.props.ga_event('Navigation', 'Member Resources Clicked');
            window.location.assign("https://www.sart.org/login?ReturnUrl=%2fprofessionals-and-providers%2fsart-members%2f");
        }
        if (target === "JoinSART") {
            this.props.ga_event('Navigation', 'Join SART Clicked');
            window.location.assign("https://www.sart.org/about-us/sart-ivf-clinic-membership/");
        }
        if (target === "Sart.org") {
            this.props.ga_event('Navigation', 'Back to Sart Clicked');
            window.location.assign("https://www.sart.org/");
        }
        if (target === "Search") {
            this.props.ga_event('Navigation', 'Back to Search Clicked');
            window.location.assign(this.props.base_url + "/Search");
        }
        if (target === "About") {
            this.props.ga_event('Navigation', 'About Us Clicked');
            window.location.assign("https://www.sart.org/about-us/start-with-sart/");
        }
        if (target === "Patients") {
            this.props.ga_event('Navigation', 'Patients Clicked');
            window.location.assign("https://www.sart.org/patients/a-patients-guide-to-assisted-reproductive-technology/");
        }
        if (target === "IVFInfo") {
            this.props.ga_event('Navigation', 'IVF Info Clicked');
            window.location.assign("https://www.sart.org/ivf-info/ivf-trends/");
        }
        if (target === "IVFSuccess") {
            this.props.ga_event('Navigation', 'IVF Success Clicked');
            window.location.assign(this.props.base_url + "/Search");
        }
        if (target === "Professionals") {
            this.props.ga_event('Navigation', 'Professionals and Providers Clicked');
            window.location.assign("https://www.sart.org/professionals-and-providers/join-sart/");
        }
        if (target === "2017Data") {
            this.props.ga_event('Navigation', '2017 Data Clicked');
            window.location.assign("https://www.sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=0&reportingYear=2017");
        }
        if (target === "2018Data") {
            this.props.ga_event('Navigation', '2018 Data Clicked');
            window.location.assign("https://www.sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=0&reportingYear=2018");
        }
        if (target === "2019Data") {
            this.props.ga_event('Navigation', '2019 Data Clicked');
            window.location.assign("https://www.sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=0&reportingYear=2019");
        }
        if (target === "2020Data") {
            this.props.ga_event('Navigation', '2020 Data Clicked');
            window.location.assign("https://www.sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=0&reportingYear=2020");
        }
        if (target === "2021Data") {
            this.props.ga_event('Navigation', '2021 Data Clicked');
            window.location.assign("https://www.sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=0&reportingYear=2021");
        }
        if (target === "2022Data") {
            this.props.ga_event('Navigation', '2022 Data Clicked');
            window.location.assign("https://www.sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=0&reportingYear=2022");
        }
        if (target === "2023Data") {
            this.props.ga_event('Navigation', '2023 Data Clicked');
            window.location.assign("https://www.sartcorsonline.com/CSR/PublicSnapshotReport?ClinicPKID=0&reportingYear=2023");
        }
        else {
            return;
        }
    }

    render() {
        return (
            <ThemeProvider theme={sartPrimaryTheme}>
                <ThemeProvider theme={sartLogoBar}>
                    <AppBar position="static" elevation={0}>
                        <Container maxWidth="xl">
                            <Toolbar disableGutters={true}>
                                <Grid container
                                    direction="row"
                                    alignItems="center">
                                    <Hidden only={['xs', 'sm']}>
                                        <Grid item xs={4}>
                                            <a href="https://www.sart.org/"><img src={sart_logo} alt="Logo" /></a>
                                        </Grid>
                                    </Hidden>
                                    <Hidden only={['xs', 'sm']}>
                                        <Grid item xs={8}>
                                            <Box style={{ float: 'right' }}>
                                                <Button onClick={() => this.navigate("MemberLogin")} className="logoNavButton primary">
                                                    Member Login
                                                </Button>
                                                <Button onClick={() => this.navigate("MemberResources")} className="logoNavButton secondary">
                                                    Member Resources
                                                </Button>
                                                <Button onClick={() => this.navigate("JoinSART")} className="logoNavButton primary">
                                                    Join SART
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Hidden>
                                    <Hidden only={['lg', 'md', 'xl']}>
                                        <Grid item xs={6}>
                                            <a href="https://www.sart.org/"><img src={sart_logo_mobile} alt="Mobile Logo" /></a>
                                        </Grid>
                                    </Hidden>
                                    <Hidden only={['lg', 'md', 'xl']}>
                                        <Grid item xs={6} >
                                            <MobileNavigationMenu base_url={this.props.base_url} navigate={this.navigate}/>
                                        </Grid>
                                    </Hidden>
                                </Grid>
                            </Toolbar>
                        </Container>
                    </AppBar>
                </ThemeProvider>
                <Hidden only={['xs', 'sm']}>
                    <AppBar position="static">
                        <Container maxWidth="xl">
                            <Toolbar disableGutters={true}>
                                <Grid container
                                    direction="row"
                                    alignItems="center">
                                    <HomeNav navigate={this.navigate}/>

                                    <Button
                                        onClick={() => this.navigate("About")}
                                        className="navigationButton"
                                    >
                                        About Us
                                    </Button>
                                    <Button
                                        onClick={() => this.navigate("Patients")}
                                        className="navigationButton"
                                    >
                                        Patients
                                    </Button>
                                    <Button
                                        onClick={() => this.navigate("IVFInfo")}
                                        className="navigationButton"
                                    >
                                        IVF Info
                                    </Button>
                                    <Button
                                        onClick={() => this.navigate("IVFSuccess")}
                                        className="navigationButton"
                                    >
                                        IVF Success
                                    </Button>
                                    <Button
                                        onClick={() => this.navigate("Professionals")}
                                        className="navigationButton"
                                    >
                                        Professionals And Providers
                                    </Button>
                                    <NationalNav navigate={this.navigate}/>
                                </Grid>
                            </Toolbar>
                        </Container>
                    </AppBar>
                </Hidden>
            </ThemeProvider>
        );
    }
}

export default Navigation;